import { Row, Col } from 'antd'
import useTranslation from '@/hooks/useTranslation'

import InputNormal from '@/components/shared-components/form/Input'
import SelectCountries from '@/components/shared-components/form/SelectCountries'

const Address = (props) => {
  const { t } = useTranslation()

  const { formValues, setFormValues, errors } = props

  return (
    <Row className='form-type_5' gutter={[16, 16]}>
      <Col xs={24} sm={12}>
        <SelectCountries
          {...{
            name: 'country',
            label: 'Paese',
            placeholder: 'Select Paese',
            value: formValues.country,
            setValue: (val) => {
              setFormValues({
                ...formValues,
                country: val,
              })
            },
            error: errors.country,
          }}
        />
      </Col>
      <Col xs={24} sm={12}>
        <InputNormal
          label={t('Province')}
          placeholder={t('Enter your province')}
          name='province'
          value={formValues.province}
          onChange={(e) =>
            setFormValues({
              ...formValues,
              province: e.target.value,
            })
          }
          error={errors?.province}
        />
      </Col>
      <Col xs={24} sm={12}>
        <InputNormal
          label={t('Città')}
          placeholder={t('Enter your city')}
          name='city'
          value={formValues.city}
          onChange={(e) =>
            setFormValues({
              ...formValues,
              city: e.target.value,
            })
          }
          error={errors?.city}
        />
      </Col>

      <Col xs={24} sm={12}>
        <InputNormal
          label={t('nome della strada')}
          placeholder={t('Inserisci nome della strada')}
          name='street'
          value={formValues.street}
          onChange={(e) =>
            setFormValues({
              ...formValues,
              street: e.target.value,
            })
          }
          error={errors?.street}
        />
      </Col>
      <Col xs={24} sm={12}>
        <InputNormal
          label={t('Numero civico')}
          placeholder={t('Inserisci Numero civico')}
          name='building_number'
          value={formValues.building_number}
          onChange={(e) =>
            setFormValues({
              ...formValues,
              building_number: e.target.value,
            })
          }
          error={errors?.building_number}
        />
      </Col>
      <Col xs={24} sm={12}>
        <InputNormal
          label={t('Codice Postale')}
          placeholder={t('Inserisci Codice Postale')}
          name='zip_code'
          value={formValues.zip_code}
          onChange={(e) =>
            setFormValues({
              ...formValues,
              zip_code: e.target.value,
            })
          }
          error={errors?.zip_code}
        />
      </Col>
    </Row>
  )
}

export default Address
